// SPANNRAHMEN IMAGES
import SpannrahmenImg2 from '../../../images/details/spannrahmen.jpg';
import SpannrahmenImg4 from '../../../images/details/alt_spannrahmen.jpg';

export const insekProductData = {
    "InsektenschutzFensterSpannrahmen": {
        defaultImages: [
            SpannrahmenImg4,
            SpannrahmenImg2,
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/spannrahmen5.png",
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/spannrahmen6.png",
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/spannrahmen7.png",
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/spannrahmen8.png",
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/spannrahmen9.png",
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/spannrahmen10.png",
        ],
        selectionData: [
            {
                title: "Fensterart",
                multichoice: false,
                options: [
                    {
                        title: "Zurückgesetzte Flügel",
                        defaultSelected: true,
                        image: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/spannrahmen1.png",
                        explanation: {
                            title: "Zurückgesetzte Flügel",
                            text: [
                                "Bitte achten Sie darauf, dass Ihr Fenster wie abgebildet aussieht.",
                                "Der erste ist 'Zurückgesetzte Flügel' und der zweite ist 'Flächenbündig'."
                            ]
                        },
                        explanationImg: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/spannrahmen3.png",
                        forbids: [],
                        price: 0
                    },
                    {
                        title: "Flächenbündig",
                        image: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/spannrahmen2.png",
                        explanation: {
                            title: "Flächenbündig",
                            text: [
                                "Bitte achten Sie darauf, dass Ihr Fenster wie abgebildet aussieht.",
                                "Der erste ist 'Zurückgesetzte Flügel' und der zweite ist 'Flächenbündig'."
                            ]
                        },
                        explanationImg: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/spannrahmen3.png",
                        forbids: [],
                        price: 0
                    }
                ]
            },
            {
                title: "Falzmaß oben",
                multichoice: false,
                titleDescription: true,
                titleDescriptionData: {
                    title: "Falzmaß oben",
                    text: [
                        "Messen Sie die Tiefe des Fensterfalzes direkt am Fensterrahmen. Diese Messung ist wichtig, um sicherzustellen, dass das Fliegengitter korrekt passt.",
                        "Das Falzmaß sollte mindestens 16 mm betragen. Dadurch wird verhindert, dass das Fliegengitter über den Fensterrahmen hinausragt. Dies berücksichtigt die Rahmendicke von 11 mm sowie einen zusätzlichen Platzbedarf von 5 mm für die Einhängewinkel oder Winkellaschen.",
                        "Im Normalfall ist das Falzmaß oben und unten gleich. Befindet sich eine Gummidichtung an der Falzkante, muss diese beim Messen berücksichtigt werden. Drücken Sie die Gummidichtung leicht zusammen, um sicherzustellen, dass der Einhängewinkel perfekt sitzt und der Spannrahmen weder zu locker noch zu straff am Fenster sitzt.",
                    ],
                    explanationImg: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/spannrahmen4.png",
                },
                options: [
                    {
                        title: "",
                        defaultSelected: true,
                        noImage: true,
                        price: {
                            "0 mm" : 0,
                            "1 mm" : 0,
                            "2 mm" : 0,
                            "3 mm" : 0,
                            "4 mm" : 0,
                            "5 mm" : 0,
                            "6 mm" : 0,
                            "7 mm" : 0,
                            "8 mm" : 0,
                            "9 mm" : 0,
                            "10 mm" : 0,
                            "11 mm" : 0,
                            "12 mm" : 0,
                            "13 mm" : 0,
                            "14 mm" : 0,
                            "15 mm" : 0,
                            "16 mm" : 0,
                            "17 mm" : 0,
                            "18 mm" : 0,
                            "19 mm" : 0,
                            "20 mm" : 0,
                            "21 mm" : 0,
                            "22 mm" : 0,
                            "23 mm" : 0,
                            "24 mm" : 0,
                            "25 mm" : 0,
                            "26 mm" : 0,
                            "27 mm" : 0,
                            "28 mm" : 0,
                            "29 mm" : 0,
                            "30 mm" : 0,
                            "31 mm" : 0,
                            "32 mm" : 0,
                            "33 mm" : 0,
                            "34 mm" : 0,
                            "35 mm" : 0,
                            "36 mm" : 0,
                            "37 mm" : 0,
                            "38 mm" : 0,
                            "39 mm" : 0,
                            "40 mm" : 0,
                        },
                        priceRemoveCurrency: true,
                        overruleActiveSelectionCheck: true,
                    }
                ]
            },
            {
                title: " Falzmaß unten",
                multichoice: false,
                titleDescription: true,
                titleDescriptionData: {
                    title: "Falzmaß unten",
                    text: [
                        "Messen Sie die Tiefe des Fensterfalzes direkt am Fensterrahmen. Diese Messung ist wichtig, um sicherzustellen, dass das Fliegengitter korrekt passt.",
                        "Das Falzmaß sollte mindestens 16 mm betragen. Dadurch wird verhindert, dass das Fliegengitter über den Fensterrahmen hinausragt. Dies berücksichtigt die Rahmendicke von 11 mm sowie einen zusätzlichen Platzbedarf von 5 mm für die Einhängewinkel oder Winkellaschen.",
                        "Im Normalfall ist das Falzmaß oben und unten gleich. Befindet sich eine Gummidichtung an der Falzkante, muss diese beim Messen berücksichtigt werden. Drücken Sie die Gummidichtung leicht zusammen, um sicherzustellen, dass der Einhängewinkel perfekt sitzt und der Spannrahmen weder zu locker noch zu straff am Fenster sitzt.",
                    ],
                    explanationImg: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/spannrahmen4.png",
                },
                options: [
                    {
                        title: " ",
                        defaultSelected: true,
                        noImage: true,
                        price: {
                            "0 mm" : 0,
                            "1 mm" : 0,
                            "2 mm" : 0,
                            "3 mm" : 0,
                            "4 mm" : 0,
                            "5 mm" : 0,
                            "6 mm" : 0,
                            "7 mm" : 0,
                            "8 mm" : 0,
                            "9 mm" : 0,
                            "10 mm" : 0,
                            "11 mm" : 0,
                            "12 mm" : 0,
                            "13 mm" : 0,
                            "14 mm" : 0,
                            "15 mm" : 0,
                            "16 mm" : 0,
                            "17 mm" : 0,
                            "18 mm" : 0,
                            "19 mm" : 0,
                            "20 mm" : 0,
                            "21 mm" : 0,
                            "22 mm" : 0,
                            "23 mm" : 0,
                            "24 mm" : 0,
                            "25 mm" : 0,
                            "26 mm" : 0,
                            "27 mm" : 0,
                            "28 mm" : 0,
                            "29 mm" : 0,
                            "30 mm" : 0,
                            "31 mm" : 0,
                            "32 mm" : 0,
                            "33 mm" : 0,
                            "34 mm" : 0,
                            "35 mm" : 0,
                            "36 mm" : 0,
                            "37 mm" : 0,
                            "38 mm" : 0,
                            "39 mm" : 0,
                            "40 mm" : 0,
                        },
                        priceRemoveCurrency: true,
                        overruleActiveSelectionCheck: true,
                        priceExplanation: ""
                    }
                ]
            },
            {
                title: "Rahmenfarbe",
                multichoice: false,
                options: [
                    {
                        title: "Weiß",
                        defaultSelected: true,
                        image: "rgb(243, 246, 246)",
                        price: 0
                    },
                    {
                        title: "Anthrazit",
                        image: "rgb(90, 90, 90)",
                        price: 0
                    },
                    {
                        title: "Sepiabraun",
                        image: "rgb(69, 55, 41)",
                        price: 0
                    },
                ]
            },
            {
                title: " Zusätzliche Sprosse",
                multichoice: false,
                titleDescription: true,
                titleDescriptionData: {
                    title: "Zusätzliche Sprosse",
                    text: [
                        "Fertigung erfolgt ab 1500 mm mit Sprosse mittig. Auf Wunsch auch ohne Sprosse möglich, ohne Gewährleistung.",
                        "Wenn die Höhe größer als 150 cm ist, empfehlen wir Ihnen, diese zu wählen.",
                        "Es ist optional.",
                    ],
                    explanationImg: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/spannrahmen11.png",
                },
                options: [
                    {
                        title: "",
                        defaultSelected: true,
                        noImage: true,
                        price: {
                            "nein": 0,
                            "nicht gewebeteilend": 30,
                            "gewebeteilend": 50
                        },
                        overruleActiveSelectionCheck: true,
                        priceExplanation: ""
                    }
                ]
            },
        ],
        defaultHeight: 400,
        defaultWidth: 500,
        cartName: "Fliegengitter Spannrahmen ",
        EXTERNAL_URL: "/api/sun-protection-product/price",
        priceType: "FENSTER",
        freeSamplingTitle: "Stoffmuster Fliegengitter für Fenster (Spannrahmen)",
        measurementUrl: "/messanleitung/plissee",
        productDetailUrl: "/api/product/Insektenschutz/Hochwertiges Fliegengitter mit Spannrahmen",
        assemblyInfo: null,
        widthText: "(500-1400 mm)",
        heightText: "(400-1900 mm)",
        moreThanOnePdf: true,
        pdfArray: [
            {
                measurementUrl: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/SE14-31.pdf",
                message: "Wenn Sie 'Fensterart' als 'Zurückgesetzte Flügel' auswählen, sehen Sie bitte SE/14-31."
            },
            {
                measurementUrl: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/SE9.pdf",
                message: "Wenn Sie 'Fensterart' als 'Flächenbündig' auswählen, sehen Sie bitte SE/9."
            }
        ],
        cartImage: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/spannrahmen5.png",
    },
    "InsektenschutzPlisseetür": {
        defaultImages: [
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/plisseetu%CC%88r0.png",
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/plisseetu%CC%88r2.png",
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/plisseetu%CC%88r3.png",
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/plisseetu%CC%88r1.png",
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/plisseetu%CC%88r4.png",
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/plisseetu%CC%88r5.png",
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/plisseetu%CC%88r6.png",
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/plisseetu%CC%88r7.png",
        ],
        selectionData: [
            {
                title: "Befestigungsart",
                multichoice: false,
                titleDescription: true,
                titleDescriptionData: {
                    title: "Befestigungsart",
                    text: [
                        "Befestigungsart Türlaibung: Diese Befestigung eignet sich für Türen mit mindestens 22 mm Platz in der Laibung und bis zu 2200 mm Breite. Bei nach außen öffnenden Türen erfolgt die Montage innen. Eine Befestigungsschiene wird an beiden Wandseiten angeschraubt, die obere Führungsschiene ebenfalls, die untere wird angeklebt. Das Plissee bleibt in jeder Position stehen und hat eine 7 mm hohe Bodenschiene.",
                        "Befestigungsart Türrahmen: Diese Befestigung ist für Türen mit mindestens 24 mm Platz vor dem Rahmen und bis zu 2200 mm Breite geeignet. Ein Montagerahmen wird auf drei Seiten des Türrahmens angeklebt oder angeschraubt. Der Rahmen muss mindestens 50 mm breit sein. Das Plissee bleibt in jeder Position stehen und hat ebenfalls eine 7 mm hohe Bodenschiene."
                    ],
                    explanationImg: null,
                },
                options: [
                    {
                        title: "",
                        defaultSelected: true,
                        noImage: true,
                        price: {
                            "Türlaibung": 0,
                            "Türrahmen": 0
                        },
                        priceRemoveCurrency: true,
                        overruleActiveSelectionCheck: true,
                    }
                ]
            },
            {
                title: "Zusätzliche Bodenleiste",
                multichoice: false,
                titleDescription: true,
                titleDescriptionData: {
                    title: "Befestigungsart",
                    text: [
                        "Falls Ihr Terrassen- oder Balkonboden uneben ist, könnte das reibungslose Öffnen und Schließen des Plissees beeinträchtigt sein. In solchen Fällen empfehlen wir die Montage einer zusätzlichen Leiste, auf der die normale Führungsschiene angebracht wird. Dadurch bleibt das Plissee parallel zu den oberen und unteren Führungsschienen ausgerichtet und kann wieder leichtgängig bedient werden.",
                        "Zur Standardhöhe der Bodenschiene von 7 mm kämen durch die zusätzliche Leiste weitere 15 mm hinzu.",
                    ],
                    explanationImg: "",
                },
                options: [
                    {
                        title: "",
                        defaultSelected: true,
                        noImage: true,
                        price: {
                            "Nein": 0,
                            "Ja": 11.90
                        },
                        priceRemoveCurrency: false,
                        overruleActiveSelectionCheck: true,
                    }
                ]
            },
            {
                title: "Profile Farbe",
                multichoice: false,
                options: [
                    {
                        title: "Weiß",
                        defaultSelected: true,
                        image: "rgb(243, 246, 246)",
                        price: 0
                    },
                    {
                        title: "Anthrazit",
                        image: "rgb(90, 90, 90)",
                        price: 0
                    },
                    {
                        title: "Sepiabraun",
                        image: "rgb(69, 55, 41)",
                        price: 0
                    },
                ]
            },
        ],
        defaultHeight: 700,
        defaultWidth: 500,
        cartName: "Plisseetür Fliegengitter",
        EXTERNAL_URL: "/api/sun-protection-product/price",
        priceType: "PLISSEETUR",
        freeSamplingTitle: "Stoffmuster Insektenschutz - Plisseetür",
        productDetailUrl: "/api/product/Insektenschutz/Insektenschutz - Plisseetür",
        assemblyInfo: null,
        widthText: "(400-2200 mm)",
        heightText: "(700-2550 mm)",
        moreThanOnePdf: true,
        pdfArray: [
            {
                measurementUrl: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/3r.pdf",
                message: "Wenn Sie 'Zusätzliche Bodenleiste' als Ja auswählen, sehen Sie bitte PL22/3R."
            },
            {
                measurementUrl: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/3ro.pdf",
                message: "Wenn Sie 'Zusätzliche Bodenleiste' als Nein auswählen, sehen Sie bitte PL22/3R0."
            }
        ],
        cartImage: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/plisseetu%CC%88r0.png",
    },
    "InsektenschutzPendeltür": {
        defaultImages: [
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/pendaltur1.png",
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/pendaltur2.png",
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/pendalturgallery1.png",
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/pendalturgallery2.png",
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/pendalturgallery3.png",
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/pendalturgallery4.png",
            "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/pendalturgallery5.png",
        ],
        selectionData: [
            {
                title: "Öffnungsrichtung",
                multichoice: false,
                options: [
                    {
                        title: "Links",
                        defaultSelected: true,
                        image: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/links.png",
                        explanation: {
                            title: "Anschlagseite",
                            text: [
                                "Die Anschlagseite wird von außen betrachtet angegeben und bezeichnet die Seite, an der sich die Türbänder (Scharniere) befinden sollen.",
                            ]
                        },
                        explanationImg: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/links.png",
                        forbids: [],
                        price: 0
                    },
                    {
                        title: "Rechts",
                        image: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/rechts.png",
                        explanation: {
                            title: "Anschlagseite",
                            text: [
                                "Die Anschlagseite wird von außen betrachtet angegeben und bezeichnet die Seite, an der sich die Türbänder (Scharniere) befinden sollen.",
                            ]
                        },
                        explanationImg: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/rechts.png",
                        forbids: [],
                        price: 0
                    }
                ]
            },
            {
                title: "Gewebeart Oben",
                multichoice: false,
                options: [
                    {
                        title: "Fieberglas Schwarz",
                        defaultSelected: true,
                        image: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/fiberglass.png",
                        explanation: {
                            title: "Haustiergewebe Schwarz",
                            text: [
                                "Gewebeart: Hier werden bald weitere Informationen zur Gewebeart verfügbar sein.",
                            ]
                        },
                        explanationImg: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/fiberglass.png",
                        forbids: [],
                        price: 0
                    },
                    {
                        title: "Haustiergewebe Schwarz",
                        image: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/hauistiergewebe.png",
                        explanation: {
                            title: "Haustiergewebe Schwarz",
                            text: [
                                "Gewebeart: Hier werden bald weitere Informationen zur Gewebeart verfügbar sein.",
                            ]
                        },
                        explanationImg: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/hauistiergewebe.png",
                        forbids: [],
                        price: 45
                    },
                    {
                        title: "Pollenschutz",
                        image: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/pollenschutz.png",
                        explanation: {
                            title: "Pollenschutz",
                            text: [
                                "Gewebeart: Hier werden bald weitere Informationen zur Gewebeart verfügbar sein.",
                            ]
                        },
                        explanationImg: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/pollenschutz.png",
                        forbids: [],
                        price: 49
                    },
                    {
                        title: "Transparentgewebe",
                        image: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/transparentgewebe.png",
                        explanation: {
                            title: "Transparentgewebe",
                            text: [
                                "Gewebeart: Hier werden bald weitere Informationen zur Gewebeart verfügbar sein.",
                            ]
                        },
                        explanationImg: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/transparentgewebe.png",
                        forbids: [],
                        price: 45
                    },

                ]
            },
            {
                title: "Gewebeart Unten",
                multichoice: false,
                options: [
                    {
                        title: "Fieberglas Schwarz",
                        defaultSelected: true,
                        image: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/fiberglass.png",
                        explanation: {
                            title: "Haustiergewebe Schwarz",
                            text: [
                                "Gewebeart: Hier werden bald weitere Informationen zur Gewebeart verfügbar sein.",
                            ]
                        },
                        explanationImg: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/fiberglass.png",
                        forbids: [],
                        price: 0
                    },
                    {
                        title: "Haustiergewebe Schwarz",
                        image: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/hauistiergewebe.png",
                        explanation: {
                            title: "Haustiergewebe Schwarz",
                            text: [
                                "Gewebeart: Hier werden bald weitere Informationen zur Gewebeart verfügbar sein.",
                            ]
                        },
                        explanationImg: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/hauistiergewebe.png",
                        forbids: [],
                        price: 45
                    },
                    {
                        title: "Pollenschutz",
                        image: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/pollenschutz.png",
                        explanation: {
                            title: "Pollenschutz",
                            text: [
                                "Gewebeart: Hier werden bald weitere Informationen zur Gewebeart verfügbar sein.",
                            ]
                        },
                        explanationImg: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/pollenschutz.png",
                        forbids: [],
                        price: 49
                    },
                    {
                        title: "Transparentgewebe",
                        image: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/transparentgewebe.png",
                        explanation: {
                            title: "Transparentgewebe",
                            text: [
                                "Gewebeart: Hier werden bald weitere Informationen zur Gewebeart verfügbar sein.",
                            ]
                        },
                        explanationImg: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/transparentgewebe.png",
                        forbids: [],
                        price: 45
                    },
                ]
            },
            {
                title: "Tierklappe",
                multichoice: false,
                options: [
                    {
                        title: "Nein",
                        defaultSelected: true,
                        image: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/no-klein.png",
                        forbids: [],
                        price: 0
                    },
                    {
                        title: "Haustierklappe klein",
                        image: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/klein.png",
                        explanation: {
                            title: "Haustierklappe klein",
                            text: [
                                "Sie können die genauen Maße im obigen Bild finden."
                            ]
                        },
                        explanationImg: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/kleindetail.png",
                        price: 180
                    },
                    {
                        title: "Haustierklappe groß",
                        image: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/gross.png",
                        explanation: {
                            title: "Haustierklappe groß",
                            text: [
                                "Sie können die genauen Maße im obigen Bild finden."
                            ]
                        },
                        explanationImg: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/grossdetail.png",
                        price: 210
                    }
                ]
            },
            {
                title: "Tierklappe Position",
                multichoice: false,
                checkAllowList: true,
                titleDescription: true,
                titleDescriptionData: {
                    title: "Tierklappe Position",
                    text: [],
                    explanationImg: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/positionierung.png",
                },
                options: [
                    {
                        title: "",
                        defaultSelected: true,
                        noImage: true,
                        price: {
                            "-         ": 0,
                            "Mittig    ": 0,
                            "Links     ": 0,
                            "Rechts    ": 0
                        },
                        priceRemoveCurrency: true,
                        overruleActiveSelectionCheck: true,
                        allows: {
                            type: "single",
                            dependecies: [
                                {"Tierklappe":"Haustierklappe klein"},
                                {"Tierklappe":"Haustierklappe groß"},
                            ]
                        },
                    }
                ]
            },
            {
                title: "Vorbohren",
                multichoice: false,
                titleDescription: true,
                titleDescriptionData: {
                    title: "Vorbohren",
                    text: [
                        "Auf Wunsch kann die Insektenschutztür seitlich vorgebohrt geliefert werden."
                    ],
                    explanationImg: null
                },
                options: [
                    {
                        title: "",
                        defaultSelected: true,
                        noImage: true,
                        price: {
                            "Nein     ": 0,
                            "Ja       ": 20,
                        },
                        priceRemoveCurrency: false,
                        overruleActiveSelectionCheck: true,
                    }
                ]
            },
            {
                title: "Rahmenfarbe",
                multichoice: false,
                options: [
                    {
                        title: "Weiß",
                        defaultSelected: true,
                        image: "rgb(243, 246, 246)",
                        price: 0
                    },
                    {
                        title: "Anthrazit",
                        image: "rgb(90, 90, 90)",
                        price: 0
                    },
                    {
                        title: "Sepiabraun",
                        image: "rgb(69, 55, 41)",
                        price: 0
                    },
                ]
            },
        ],
        defaultHeight: 1500,
        defaultWidth: 800,
        cartName: "Insektenschutz von Hell: Fliegengitter für Pendeltür",
        EXTERNAL_URL: "/api/sun-protection-product/price",
        priceType: "PENDELTUR",
        freeSamplingTitle: "Stoffmuster Insektenschutz - Pendeltür",
        productDetailUrl: "/api/product/Insektenschutz/Insektenschutz - Pendeltür",
        assemblyInfo: null,
        widthText: "(600-1300 mm)",
        heightText: "(1500-2250 mm)",
        measurementUrl: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/pendeltur.pdf",
        isMesurementRedirect: true,
        cartImage: "https://hell-insekten-sonnenschutz-cdn.s3.eu-central-1.amazonaws.com/pendaltur1.png",
    }
};
